<template>
    <div class="navigation-account__footer d-block mt-auto">
        <language-menu />

        <hr class="navigation-account__footer-hr hr-content" />

        <ul class="navigation-account__social-list list-unstyled">
            <li v-if="userIsAdmin" class="navigation-account__social-item">
                <router-link
                    class="navigation-account__social-link d-flex align-items-center"
                    :to="{ name: $options.ROUTES_ADMIN.DASHBOARD }"
                >
                    <span class="navigation-account__social-link-icon"><iconAdmin class="d-block"/></span>
                    <span class="navigation-account__social-link-text">{{ $t('switchToAdmin') }}</span>
                </router-link>
            </li>
            <li class="navigation-account__social-item">
                <a
                    class="navigation-account__social-link d-flex align-items-center"
                    target="_blank"
                    rel="noopener"
                    href="https://www.facebook.com/ludumHQ/"
                >
                    <span class="navigation-account__social-link-icon"><iconFacebook class="d-block"/></span>
                    <span class="navigation-account__social-link-text">{{ $t('facebook') }}</span>
                </a>
            </li>
            <li class="navigation-account__social-item">
                <a
                    class="navigation-account__social-link d-flex align-items-center"
                    target="_blank"
                    rel="noopener"
                    href="https://twitter.com/LudumHQ"
                >
                    <span class="navigation-account__social-link-icon"><iconTwitter class="d-block"/></span>
                    <span class="navigation-account__social-link-text">{{ $t('twitter') }}</span>
                </a>
            </li>
            <li class="navigation-account__social-item">
                <a
                    class="navigation-account__social-link d-flex align-items-center"
                    target="_blank"
                    rel="noopener"
                    href="https://www.instagram.com/ludumhq/"
                >
                    <span class="navigation-account__social-link-icon"><iconInstagram class="d-block"/></span>
                    <span class="navigation-account__social-link-text">{{ $t('instagram') }}</span>
                </a>
            </li>
        </ul>

        <span @click="toggleNavigation()" class="navigation-account__toggle-buttons d-none d-lx-block d-lg-block">
            <span class="navigation-account__toggle-button navigation-account__toggle-button-open">
                <iconOpen class="d-block" />
            </span>
            <span class="navigation-account__toggle-button navigation-account__toggle-button-close">
                <iconClose class="d-block" />
            </span>
        </span>

        <div class="navigation-account__footer-copyright d-flex align-content-start">
            <div class="navigation-account__footer-copyright-logo mr-3"><logoImg /></div>
            <div class="navigation-account__footer-copyright-text-content flex-grow-1">
                <span class="navigation-account__footer-copyright-text d-block">© {{ year }} Ludum</span>
                <span class="navigation-account__footer-copyright-text d-block">{{ $t('allRightsReserved') }}</span>
                <a
                    class="navigation-account__footer-copyright-link d-block"
                    target="_blank"
                    href="https://ludum.com/terms-and-conditions/"
                    rel="noopener"
                >
                    {{ $t('tcs') }} →
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { YEAR_FORMAT } from '@/constants/dateTimeFormats';
import { ROUTES_ADMIN } from '@/constants/routes';
import { LudumEventBus, TOGGLE_NAVIGATION } from '@/event-bus';
import LanguageMenu from './NavigationMenuLanguage';
import iconClose from '@/assets/img/account/nav-icons/button-close.svg?inline';
import iconOpen from '@/assets/img/account/nav-icons/button-open.svg?inline';
import iconAdmin from '@/assets/img/account/nav-icons/soc-admin.svg?inline';
import iconFacebook from '@/assets/img/account/nav-icons/soc-facebook.svg?inline';
import iconInstagram from '@/assets/img/account/nav-icons/soc-instagram.svg?inline';
import iconTwitter from '@/assets/img/account/nav-icons/soc-twitter.svg?inline';
import logoImg from '@/assets/img/general/logo.svg?inline';

export default {
    ROUTES_ADMIN,

    components: {
        LanguageMenu,
        logoImg,
        iconAdmin,
        iconFacebook,
        iconInstagram,
        iconTwitter,
        iconClose,
        iconOpen
    },

    methods: {
        toggleNavigation() {
            LudumEventBus.$emit(TOGGLE_NAVIGATION);
        }
    },

    computed: {
        ...mapGetters({
            me: 'clubHelper/me'
        }),

        year() {
            return moment().format(YEAR_FORMAT);
        },

        userIsAdmin() {
            return this.me && this.me.is_admin;
        }
    }
};
</script>
